export const PAGE_FILTER_NAME = "pages";
export const STATUS_FILTER_NAME = "statuses";
